import React from 'react';

import Button from '../components/ButtonNew';
import Link from '../components/Link';
import {DUET_SESSIONS_PER_PERIOD} from '../../../lib/constants/duet';
import {cx} from '../util';

const ProgressCircle = ({numerator, denominator, className}) => {
  const percentage = (numerator / denominator) * 100;
  const strokeDashoffset = 100 - percentage;

  return (
    <svg className={cx(className)} viewBox="0 0 36 36">
      <circle
        className="text-gray-300"
        stroke="currentColor"
        strokeWidth="4"
        fill="transparent"
        r="16"
        cx="18"
        cy="18"
      />
      <circle
        className="text-indigo-600"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        fill="transparent"
        r="16"
        cx="18"
        cy="18"
        strokeDasharray="100"
        strokeDashoffset={strokeDashoffset}
        transform="rotate(-90 18 18)"
        style={{
          transition: 'all 0.5s ease-in-out',
        }}
      />
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        className="fill-current text-gray-700"
        style={{
          fontSize: '0.7rem',
          fontWeight: '600',
          userSelect: 'none',
        }}
      >
        {`${numerator}/${denominator}`}
      </text>
    </svg>
  );
};


const DuetPeerMockCreditCounter = ({freePeerSessions, onClick}) => (
  <div className="p-5 rounded-2xl border border-blue-100 bg-blue-50 shadow-sm mb-10">
    <div className="flex items-center justify-between sm:flex-row flex-col">
      <div className="flex items-center">
        <ProgressCircle
          numerator={DUET_SESSIONS_PER_PERIOD - freePeerSessions}
          denominator={DUET_SESSIONS_PER_PERIOD}
          className="h-10 w-10 mr-3 shrink-0"
        />
        <div>
          <div className="text-gray-700 font-medium">
            {`${freePeerSessions} peer mock interview${freePeerSessions === 1 ? '' : 's'} remaining`}
          </div>
          <div>
            Credits replenish over time and when you receive positive feedback.
            {' '}
            <Link
              href="/upgrade?src=duet-peer-mocks"
              className="text-indigo font-semibold sm:hidden"
              onClick={onClick}
            >
              Get unlimited sessions.
            </Link>
          </div>
        </div>
      </div>

      <Button
        href="/upgrade?src=duet-peer-mocks"
        onClick={onClick}
        className="ml-3 hidden sm:block whitespace-nowrap"
      >
        Get unlimited sessions
      </Button>
    </div>
  </div>
);

export default DuetPeerMockCreditCounter;
